import React from 'react';
import HTMLComment from 'react-html-comment';
import clsx from 'clsx';

export interface ConsentOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
    text: string;
    buttonLabel: string;
    onAccept?: () => void;
}

const ConsentOverlay: React.FC<ConsentOverlayProps> = ({ className, text, buttonLabel, onAccept, ...props }) => {
    return (
        <>
            <HTMLComment text={'@component: ConsentOverlay - Start'} />
            {className && <HTMLComment text={`Additional classes from component "${className}"`} />}
            <div
                className={clsx(
                    'absolute inset-0 z-10 flex flex-col items-center justify-center bg-darkblue bg-opacity-90 p-6 text-center text-white',
                    className
                )}
                {...props}
            >
                {text && <p className={'mb-4 text-lg'}>{text}</p>}
                <button
                    type={'button'}
                    onClick={onAccept}
                    className={clsx(
                        'flex max-w-full items-center justify-center overflow-hidden rounded outline-none transition-all',
                        'border border-blue-700 bg-blue stroke-white stroke-[0.5px] text-white',
                        'hover:border-blue hover:bg-blue-900',
                        'focus-visible:focus-outline',
                        'p-[14px]'
                    )}
                >
                    {buttonLabel}
                </button>
            </div>
            <HTMLComment text={'@component: ConsentOverlay - End'} />
        </>
    );
};

export default ConsentOverlay;
